<template>
  <div>
    <div class="vd-gl-search-form">
      <a-form layout="inline">
        <a-form-item label="姓名">
          <a-input v-model="search.username" placeholder="推广员姓名" />
        </a-form-item>
        <a-form-item label="编号">
          <a-input v-model="search.code" placeholder="推广员编号" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" icon="search" @click="getData" />
        </a-form-item>
      </a-form>
    </div>
    <a-table
      row-key="id"
      :data-source="list"
      :scroll="{ x: 1200 }"
      :pagination="pagination"
    >
      <a-table-column title="ID" data-index="id" fixed="left" />
      <a-table-column-group align="center" title="推广人">
        <a-table-column align="center" title="用户名" data-index="agent" />
        <a-table-column align="center" title="地区" data-index="area_name" />
      </a-table-column-group>
      <a-table-column align="center" title="数据包" data-index="package_name" />
      <a-table-column align="center" title="过期时间" data-index="due_time" />
      <a-table-column align="center" title="二维码" data-index="qr_code">
        <template slot-scope="text">
          <a-tooltip>
            <template slot="title">
              <img
                :src="$HelperUtil.isEmpty(text) ? '' : text"
                alt="二维码"
                style="width: 160px"
              />
            </template>
            <a-avatar
              :src="$HelperUtil.isEmpty(text) ? '' : text"
              shape="square"
              :size="84"
              style="border: #999999 1px solid"
              >二维码
            </a-avatar>
          </a-tooltip>
        </template>
      </a-table-column>
      <a-table-column align="center" title="资料领取封面" data-index="face">
        <template slot-scope="text">
          <a-tooltip>
            <template slot="title">
              <img :src="text" alt="封面" style="height: 200px" />
            </template>
            <img :src="text" style="border: #999999 1px solid;height: 100px" />
          </a-tooltip>
        </template>
      </a-table-column>
      <a-table-column align="center" title="创建人" data-index="creator_name" />
      <a-table-column align="center" title="扫码人数" data-index="complete" />
      <a-table-column align="center" title="操作" fixed="right">
        <template slot-scope="text">
          <a-tooltip
            title="生成二维码"
            v-if="$HelperUtil.isEmpty(text.qr_code)"
          >
            <a-icon class="common-icon" type="qrcode" @click="createQr(text)" />
          </a-tooltip>
          <a-tooltip v-else title="下载二维码">
            <!-- <a-icon
              class="common-icon"
              type="download"
              @click="
                downloadQr(
                  text.qr_code,
                  text.activity_id + '-' + text.a_name + '-' + text.area_name
                )"
            /> -->
          </a-tooltip>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { getBookMember, create_qr } from '@/api/book'

export default {
  name: 'DetailMember',
  data() {
    return {
      id: 0,
      search: {
        username: '',
        code: '',
      },
      list: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getData()
  },
  methods: {
    getData() {
      getBookMember({
        id: this.id,
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        if (res['code'] === 1) {
          this.list = res['list']
          this.pagination.total = res['total']
        }
      })
    },
    createQr(item) {
      if (!item.qr_url) {
        create_qr({ memberId: item.id }).then((res) => {
          if (res['code'] === 1) {
            this.$message.success('创建成功')
            this.getData()
          } else {
            this.$message.warn(res['msg'])
          }
        })
      }
    },
    downloadQr(url, filename) {
      let img = new Image()
      img.setAttribute('crossOrigin', 'Anonymous')
      img.onload = function() {
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')
        canvas.width = img.width
        canvas.height = img.height
        context.drawImage(img, 0, 0, img.width, img.height)
        let url = canvas.toDataURL('images/png')
        let a = document.createElement('a')
        let event = new MouseEvent('click')
        a.download = filename + '.png'
        a.href = url
        a.dispatchEvent(event)
      }
      img.src = url
    },
    onSearch() {},
  },
}
</script>

<style scoped></style>
